<template>
  <div class="_dropzone">
    <vue2Dropzone 
      id="_dropzone__dropzone"
      ref="vueDropzone"
      :options="dropzoneOptions"
    />
  </div>
</template>

<script>
import _ from "lodash";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  name: "AttachmentsDropzone",
  mixins: [],
  components: {
    vue2Dropzone,
  },
  props: {
    value: {
      required: false,
    },
    config: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      previewImage: null,
      previewName: '',
      dropzoneOptions: {
        disablePreview: true,
        maxFiles: 99,
        maxFilesize: 9999999,
        url: '#',
        autoProcessQueue: false,
        autoQueue: false,
        addRemoveLinks: false,
        // addedfile: this.onAddedFile,
        addedfiles: this.onAddedFiles,
        styling: false,
      },
    }
  },
  methods: {
    onAddedFiles(fileList) {
      this.$emit('addedFiles', fileList)
      this.$refs.vueDropzone.removeAllFiles()
    },
    loadPreview(file) {
      const fileReader = new FileReader();
      fileReader. addEventListener('load', event => {
        this.previewImage = event. target. result;
        this.previewName = file.name;
      });
      fileReader.readAsDataURL(file);
    }
  },
  watch: {
    config: {
      immediate: true,
      handler: function() {
        // URL is mandatory option
        if (this.config && this.config.url) {
          this.dropzoneOptions = _.cloneDeep(this.config);
        }
      }
    }
  }
};
</script>

<style lang="scss">
._dropzone {
  position: relative;
  margin-bottom: 2rem;
  
  .vue-dropzone {
    height: 120px;
    min-height: auto;
    padding: 0;
    background-color: transparent;
    border: 1px solid #ccc;
    border-radius: 2px;
    text-align: center;
    color: inherit;
    font-weight: 500;
  }
}

._dropzone__preview {
  z-index: -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

._dropzone__preview__img {
  display: block;
  width: 96px !important;
  height: 96px !important;
  margin: 3rem auto 0;
  border-radius: 50%;
  box-shadow: 0 1em 5em rgba(0, 0, 0, 0.15);
  object-fit: cover;
}

._dropzone__preview__name {
  padding: 10px;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}
</style>